import * as React from "react";
import { Row } from "shards-react";
import styled from "styled-components";

const FormRow = styled(Row)`
  margin-bottom: 1rem;
`;

export default FormRow;
